import { render } from "./EditBulkForm.vue?vue&type=template&id=7a74d3c3&ts=true"
import script from "./EditBulkForm.vue?vue&type=script&lang=ts"
export * from "./EditBulkForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__